<template>
  <section>
    <Order ref="order" />
    <Dispatch ref="dispatch" />
    <Remark ref="remark" :orderId="orderId" @load="getData"/>
    <AuditLog ref="auditLog" :orderId="orderId"/>
  </section>
</template>

<script>
import {
  queryOrderDetail,
  queryOrderVerDetail,
  findOrderRecive,
} from 'api/operate';
import {getAllVehicleInfo} from 'api/car';
import Order from './order';
import Dispatch from './dispatch';
import Remark from './remark';
import AuditLog from './auditLog';
export default {
  components: {
    Order,
    Dispatch,
    Remark,
    AuditLog,
  },
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
      loadingOrderId: null,
    };
  },
  methods: {
    async getData () {
      const orderId = this.orderId || this.$route.query.id;
      if (this.loadingOrderId === orderId) {
        return;
      }
      this.loadingOrderId = orderId;
      try {
        this.$refs.auditLog.getData();
        const detailRes = await queryOrderDetail({
          orderId,
          // 生产旧版 OrderBO 仅接受 2/3；详情沿用原有 3，仅通过 skipReportCost 跳过慢成本报表。
          orderDetailsType: 3,
          skipReportCost: 1,
        });

        if (!detailRes.failed && detailRes.orderScheduler && detailRes.orderScheduler.vehicleCode) {
          const vehicleRes = await getAllVehicleInfo({
            vehicleCode: detailRes.orderScheduler.vehicleCode,
          });
          // getAllVehicleInfo 返回单个车辆对象；订单配置必须使用车辆所属车队租户。
          detailRes.vehicleInfo = vehicleRes || {};
        }

        if (detailRes.failed) {
          const confirmRes = await this.$confirm('很抱歉，正在维修保养中，请稍后再试！', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning',
          }).catch(() => { // 取消删除
          });
          if (confirmRes) {
            this.close();
          }
        }

        let detailVerRes = {};
        if (detailRes.orderInfo && detailRes.orderInfo.orderUpdateState === 2) {
          if (this.$route.query.type === 'approve') {
            detailVerRes = await queryOrderVerDetail({
              orderId,
            });
          }
        }

        const resReceipts = await findOrderRecive({
          orderId,
        });

        if (!detailRes.failed) {
          if (resReceipts.items && resReceipts.items.length) {
            detailRes.receipts = resReceipts.items;
          }
          // 合并 详情数据 和 审核数据，方便对比
          const combindDetailRes = Object.assign({isVerity: this.$route.query.isVerity}, detailVerRes, detailRes);
          this.$nextTick(() => {
            this.$refs.order.getData(combindDetailRes);
            this.$refs.dispatch.getData(combindDetailRes);
            this.$refs.remark.getData(combindDetailRes);
          });
        }
      } finally {
        if (this.loadingOrderId === orderId) {
          this.loadingOrderId = null;
        }
      }
    },
  },
};
</script>


<style lang="scss">
.order-detail-content-box {
  padding: 5px 0;
  .order-detail-content-item {
    line-height: 30px;
    .order-detail-content-item-label {
      display: inline-block;
      width: 90px;
    }
  }
}
</style>
